<!--
 * @Author: wsx
 * @Date: 2022-01-24 17:04:32
 * @LastEditTime: 2022-06-13 12:13:54
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:街道表单
-->
<template>
  <el-dialog v-model="dialogVisible" :title="topTitle" width="30%">
    <el-form
      ref="formRef"
      label-width="100px"
      class="demo-dynamic"
      :model="formData"
      :disabled="isDisabled"
      :rules="rules"
    >
      <el-form-item label="父级">
        <el-input disabled v-model="parent"></el-input>
      </el-form-item>
      <el-form-item prop="name" :label="lableTitle">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
      <template
        v-if="
          params.type == '-1' ||
          params.type == '0' ||
          params.type == '1' ||
          params.type == '2'
        "
      >
        <el-form-item prop="saveDeptIdList" label="所属部门">
          <el-cascader
            v-model="formData.saveDeptIdList"
            :options="deptTree"
            :props="props"
            :show-all-levels="false"
            style="width: 100%"
            clearable
          />
        </el-form-item>
      </template>
      <!--  -->
      <template v-if="params.type == '2' || params.type == '3'">
        <el-form-item label="网格员">
          <el-input v-model="formData.gridMember"></el-input>
        </el-form-item>
      </template>
      <template v-if="params.type == '2'">
        <el-form-item label="小区地址">
          <el-input v-model="formData.address"></el-input>
        </el-form-item>
        <el-form-item label="物业联系人">
          <el-input v-model="formData.contactName"></el-input>
        </el-form-item>
        <el-form-item label="物业联系方式">
          <el-input v-model="formData.contactPhone"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="车位数" v-if="params.type == '2'">
        <el-input v-model.number="formData.parkNum"></el-input>
      </el-form-item>
      <!-- params.type == '4' ||                原先4也是可以的 -->
      <template v-if="params.type === '4'">
        <el-form-item label="起始楼层">
          <el-input
            :disabled="type === 2"
            v-model="formData.startFloor"
          ></el-input>
        </el-form-item>
        <el-form-item label="结束楼层">
          <el-input
            :disabled="type === 2"
            v-model="formData.endFloor"
          ></el-input>
        </el-form-item>
        <el-form-item label="房间数">
          <el-input
            :disabled="type === 2"
            v-model="formData.roomNum"
          ></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="经度">
          <el-input v-model="formData.longitude"></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model="formData.latitude"></el-input>
        </el-form-item>
        <el-form-item label="缩放等级">
          <el-input v-model="formData.zoom"></el-input>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <span class="dialog-footer" v-if="!isDisabled">
        <h-button type="primary" @click="submitForm()">提交</h-button>
        <h-button @click="dialogVisible = false">取消</h-button>
        <h-button
          @click="drawAreaBtn"
          v-if="params.type != '5' && params.type != '4'"
          >绘制区域
        </h-button>
        <h-button @click="getCoordinates">获取坐标</h-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, toRefs, watch, ref } from "vue";
import { queryDeptList, queryOrganList } from "@/api/system";
import { ElMessage } from "element-plus";
import { addRegions, updateRegions } from "@/api/system/region";
import util from "@util/js";
import _ from "lodash";
export default defineComponent({
  name: "StreetForm",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      emitPath: false,
    },
    type: {
      type: Number,
      default: 1, // 1:添加；2:编辑；3:只读
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    tabsVal: {
      type: String,
    },
    from: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["drawArea", "getCoordinates", "update:modelValue", "submit"],
  setup(props, { emit }) {
    const state = reactive({
      topTitle: "",
      lableTitle: "名称",
      parent: "",
      dialogVisible: false,
      isDisabled: false,
      coordinate: "",
      props: {
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        label: "name",
        value: "deptId",
      },
      deptTree: [],
      formData: {
        // apiType: 'street',
        parentId: "",
        saveDeptIdList: [], // 部门
        coord: [], // 坐标
        name: "",
        longitude: "", // 经度
        parkNum: "", // 车位数
        latitude: "", // 纬度
        type: "", // props.params.type
        contactName: "", // 联系人
        contactPhone: "", // 联系方式
        address: "", // 地址
        startFloor: "", // 起始楼层
        endFloor: "", // 结束楼层
        remark: "", // 备注,
        roomNum: "", // 房间数
        gridMember: "", // 网格员
        zoom: "", // 缩放等级
      },
      formBack: {},
      rules: {
        name: [
          {
            required: true,
            message: `请输入`,
            trigger: "blur",
          },
        ],
        saveDeptIdList: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个部门",
            trigger: "change",
          },
        ],
      },
    });
    state.formBack = _.cloneDeep(state.formData);
    const refData = toRefs(state);
    const formRef = ref(null);
    // 重置表单
    const resetForm = () => {
      if (!formRef.value) return;
      formRef.value.resetFields();
    };

    // 监听区域树选中变化
    watch(
      [() => props.params, () => props.type],
      (v) => {
        resetForm(formRef.value);
        state.isDisabled = false;
        switch (props.type) {
          case 1: // 添加
            state.formData = _.cloneDeep(state.formBack);
            break;
          case 2: // 修改
            state.formData = _.cloneDeep(props.params);
            if (state.formData.coord && state.formData.coord != "[]") {
              state.formData.coord = JSON.parse(state.formData.coord);
            }
            if (state.formData.deptList && state.formData.deptList.length) {
              state.formData.saveDeptIdList = state.formData.deptList.map(
                (item) => {
                  return Number(item.deptId);
                }
              );
            } else {
              state.formData.saveDeptIdList =
                state.formData.levelId &&
                state.formData.levelId
                  .split("/")
                  .filter((item) => item !== "")
                  .map((item) => {
                    return Number(item);
                  });
            }
            break;
          case 3: // 只读
            state.formData = _.cloneDeep(props.params);
            if (state.formData.coord && state.formData.coord != "[]") {
              state.formData.coord = JSON.parse(state.formData.coord);
            }
            if (state.formData.deptList && state.formData.deptList.length) {
              state.formData.saveDeptIdList = state.formData.deptList.map(
                (item) => {
                  return Number(item.deptId);
                }
              );
            } else {
              state.formData.saveDeptIdList =
                state.formData.levelId &&
                state.formData.levelId
                  .split("/")
                  .filter((item) => item !== "")
                  .map((item) => {
                    return Number(item);
                  });
            }
            state.isDisabled = true;
            break;
        }
      },
      { immutable: true, deep: true }
    );
    // 监听弹框显示
    watch(
      () => props.modelValue,
      (v) => {
        state.dialogVisible = v;
        state.topTitle =
          (props.type === 1 ? "添加" : props.type === 2 ? "编辑" : "详情") +
          props.params.name;
        if (props.params.levelName) {
          state.parent =
            props.params.levelName.split("/")[
              props.params.levelName.split("/").length - 2
            ];
        } else {
          state.parent = props.params.name;
        }
      },
      { immutable: true }
    );
    watch(
      () => state.dialogVisible,
      (v) => {
        emit("update:modelValue", v);
      }
    );
    watch(
      () => props.params,
      (v) => {
        if (v.type === "-1") {
          state.lableTitle = "街道名称";
        } else if (v.type === "0") {
          state.lableTitle = "社区名称";
        } else if (v.type === "1") {
          state.lableTitle = "网格名称";
        } else if (v.type === "2") {
          state.lableTitle = "小区名称";
        } else if (v.type === "3") {
          state.lableTitle = "楼栋名称";
        } else if (v.type === "4") {
          state.lableTitle = "单元名称";
        } else if (v.type === "5") {
          state.lableTitle = "单元名称";
        }
      }
    );
    // 获取坐标按钮
    const getCoordinates = () => {
      emit("getCoordinates");
    };
    // 绘制区域按钮
    const drawAreaBtn = () => {
      console.log(state.formData, props.params, 555555);
      emit("drawArea", state.formData);
    };
    // 获取部门列表
    const queryOrganListAsync = async () => {
      const res = await queryOrganList();
      const options = { pid: "parentId", id: "deptId", rootPid: res.top };
      const treeData = util.arrayToTree(res.deptList, options);
      if (treeData[0].deptId === 0) {
        treeData[0].disabled = true;
      }
      state.deptTree = treeData;
      // props.tabsVal
    };
    queryOrganListAsync();

    // 提交数据
    const submitForm = async () => {
      formRef.value.validate(async (valid) => {
        if (!valid) return;
        state.formData.type = props.tabsVal; // props.params.type;tabsVal
        state.formData.parentId = props.params.id;
        const form = _.cloneDeep(state.formData);
        // util.formatForm(form);
        // if (form.saveDeptIdList && form.saveDeptIdList.length !== 1) {
        //   form.saveDeptIdList = form.saveDeptIdList.map(
        //     item => item[item.length - 1]
        //   );
        // }
        if (Array.isArray(form.coord)) {
          form.coord = JSON.stringify(form.coord);
        }

        let res;
        if (props.type === 1) {
          res = await addRegions(form);
        } else if (props.type === 2) {
          res = await updateRegions(form);
        }
        if (res.code === 0) {
          ElMessage.success(props.type === 1 ? "添加成功" : "修改成功");
          resetForm(formRef.value);
          state.dialogVisible = false;
          emit("submit");
        }
      });
    };
    // 设置经纬度
    const setPoint = (point, setZoom) => {
      const [longitude, latitude] = point;
      const zoom = parseInt(setZoom) + 1;
      // state.formData.coord = point;
      Object.assign(state.formData, { longitude, latitude, zoom });
    };
    // 设置区域坐标
    const setPointPath = (path) => {
      console.log(path.corrdinates);
      if (path.corrdinates.length > 0) {
        console.log(state.formData.coord);
        state.formData.coord = [...path.corrdinates];
      } else {
        state.formData.coord = [];
      }
    };

    return {
      ...refData,
      formRef,
      getCoordinates,
      drawAreaBtn,
      submitForm,
      setPoint,
      setPointPath,
    };
  },
});
</script>
<style lang="scss" scoped>
.StreetForm {
}
</style>
